import { formatLagosDate } from "./tripLog";

// "just now", "12s ago", "5m ago", "3h ago", then the date.
export const timeAgo = (date, now = Date.now()) => {
  if (!date) return null;
  const s = Math.max(0, Math.round((now - new Date(date).getTime()) / 1000));
  if (s < 5) return "just now";
  if (s < 60) return `${s}s ago`;
  if (s < 3600) return `${Math.floor(s / 60)}m ago`;
  if (s < 86400) return `${Math.floor(s / 3600)}h ago`;
  return formatLagosDate(date);
};
